"use client";
import React, { useEffect, useState } from "react";
import AcitvityDetail from "./ActivityDetail";
import Daypackages from "./Daypackages";
import { useActivities } from "@/context/Activities";
import { useCollections } from "@/context/Collections";


function OtherActivitiesMain({ activity }: { activity: string }) {
  const [isLoading, setIsLoading] = useState(true); // Loader state

  const { activiti, fetchActivity } = useActivities();
  const { fetchCollectionss, collectionss } = useCollections();

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      await fetchActivity(activity);
      await fetchCollectionss(activity);
      setIsLoading(false);
    };

    fetchData();
  }, [activity]);

 

  return (
    <div>
      {isLoading ? (
        // Skeleton Loader
        <div className="w-full">
          {/* Main Content Skeleton */}
          <div className="lg:w-11/12 w-11/12 3xl:w-8/12 mx-auto md:mt-20 mt-10">
            <div className="mx-auto py-[4rem] px-2">
              <div className="grid lg:grid-cols-6 grid-cols-1 gap-8">
                {/* Left Column - Text Content */}
                <div className="col-span-3 space-y-4">
                  {/* Title Skeleton */}
                  <div className="h-10 bg-gray-200 rounded w-3/4 animate-pulse"></div>
                  
                  {/* Description Skeleton */}
                  <div className="space-y-3 mt-6">
                    <div className="h-4 bg-gray-200 rounded w-full animate-pulse"></div>
                    <div className="h-4 bg-gray-200 rounded w-full animate-pulse"></div>
                    <div className="h-4 bg-gray-200 rounded w-5/6 animate-pulse"></div>
                    <div className="h-4 bg-gray-200 rounded w-full animate-pulse"></div>
                    <div className="h-4 bg-gray-200 rounded w-4/5 animate-pulse"></div>
                  </div>
                </div>

                {/* Right Column - Images Grid */}
                <div className="col-span-3">
                  <div className="grid grid-cols-2 gap-4">
                    {/* First Image */}
                    <div className="relative w-full h-[15em] bg-gray-200 rounded-lg animate-pulse"></div>
                    {/* Second Image */}
                    <div className="relative w-full h-[15em] bg-gray-200 rounded-lg animate-pulse"></div>
                    {/* Third Image - Full Width */}
                    <div className="col-span-2 relative w-full h-[15em] bg-gray-200 rounded-lg animate-pulse"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Packages Section Skeleton */}
          <div className="container mx-auto px-4 py-12">
            <div className="h-10 bg-gray-200 rounded w-64 mx-auto mb-8 animate-pulse"></div>
            
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {[1, 2, 3, 4, 5, 6].map((i) => (
                <div key={i} className="bg-white rounded-lg border border-gray-200 overflow-hidden animate-pulse">
                  <div className="h-48 bg-gray-200"></div>
                  <div className="p-4 space-y-3">
                    <div className="h-6 bg-gray-200 rounded w-3/4"></div>
                    <div className="h-4 bg-gray-200 rounded w-full"></div>
                    <div className="h-4 bg-gray-200 rounded w-5/6"></div>
                    <div className="h-10 bg-gray-200 rounded mt-4"></div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      ) : (
        <>
          {(activiti || collectionss) && (
            <AcitvityDetail
              activity={activity}
              activiti={activiti || collectionss}
            />
          )}

          <div>
            <Daypackages activity={activity} />
          </div>
        </>
      )}
    </div>
  );
}

export default OtherActivitiesMain;
